











































































/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { ObjectHelper } from '@fruitpackage/helpers';
import { StepMixin, ErrorResponseMixin, MessageMixin } from '@mixin';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            next: {
                text: 'Uitnodiging sturen',
                disabled: true,
            },
            errorData: null,
            post: {
                gender: 2,
                initials: '',
                lastname: '',
                lastname_prefix: '',
                function: '',
                email: '',
                phone: '',
                admin: 1,
            }
        };
    },

    mixins: [
        StepMixin,
        ErrorResponseMixin,
        MessageMixin
    ],

    methods: {
        async onNext() {
            return this.$validator.validate().then(valid => {
                if (!valid) return false;

                this.post.organisation_id = this.current.organisation_id;
                this.post.url = `${ this.$root.env.baseUrl }/invited`

                return this.$store.dispatch('user/invite', {
                    ...this.post
                }).then(response => {
                    if (response instanceof Error) {
                        this.errorData = this.getErrorMessage(response);
                        return false;
                    }

                    this.showMessage('tekenbevoegd-added', { 
                        ...this.post, 
                        organisation: this.current.organisation.name,
                        community: this.current.organisation.community,
                    });

                    return true;
                });
            });
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Tekenbevoegd extends Vue {

}

